var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutBoxRFill = function SvgLogoutBoxRFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.2 21a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9h12.6a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9zm9-5.4 4.5-3.6-4.5-3.6v2.7H9.8v1.8h5.4z"
  })));
};
export default SvgLogoutBoxRFill;